import { useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";

export function useWishlist(localStorageKey = "wishlist", initialValue = []) {
  const [wishlist, setWishlist] = useLocalStorage(localStorageKey, initialValue, {
    serializer: JSON.stringify,
    deserializer: JSON.parse,
  });

  // Adds a product ID to the wishlist
  const addToWishlist = useCallback(
    async (id) => {
      
      const normalizedProductId = String(id);
      
      if (!normalizedProductId || typeof normalizedProductId !== "string") {
        console.warn("Product ID must be a non-empty string.");
        return;
      }

      setWishlist((prevIds) => {
        if (prevIds.includes(normalizedProductId)) {
          console.info(`Product ID "${normalizedProductId}" is already in the wishlist.`);
          return prevIds;
        }
        return [...prevIds, normalizedProductId];
      });
    },
    [setWishlist]
  );

  // Removes a product ID from the wishlist
  const removeFromWishlist = useCallback(
    async (id) => {
      
      const normalizedProductId = String(id);

      if (!normalizedProductId || typeof normalizedProductId !== "string") {
        console.warn("Product ID must be a non-empty string.");
        return;
      }

      setWishlist((prevIds) => {
        if (!prevIds.includes(normalizedProductId)) {
          console.info(`Product ID "${normalizedProductId}" is not in the wishlist.`);
          return prevIds;
        }
        return prevIds.filter((productId) => productId !== normalizedProductId);
      });
    },
    [setWishlist]
  );

  // Clears all product IDs from the wishlist
  const clearWishlist = useCallback( async () => {
    setWishlist([]);
  }, [setWishlist]);

  // Checks if a product ID exists in the wishlist
  const isInWishlist = useCallback(
    async (id) => {
            
      const normalizedProductId = String(id);
      
      if (!normalizedProductId || typeof normalizedProductId !== "string") {
        console.warn("Product ID must be a non-empty string.");
        return false;
      }
      return wishlist.includes(normalizedProductId);
    },
    [wishlist]
  );

  return {
    wishlist,
    addToWishlist,
    removeFromWishlist,
    clearWishlist,
    isInWishlist,
  };
}
